import React, { useState } from "react";

import {
  Card,
  Typography,
  Pagination,
  Table,
  Popconfirm,
  message,
  Checkbox,
  Tooltip,
  Modal,
  List,
} from "antd";
import CommonTopDetails from "../../../../components/AdminComponents/CommonTopDetails";
import { useParams } from "react-router-dom";
import useCommonListing from "../../../../components/AdminComponents/customHooks/useCommonListing";
import { GetFormattedDateTime } from "../../../../components/utils/DateTimeUtils";
import { DeleteTwoTone } from "@ant-design/icons";
import BulkClientsAdd from "../../../../components/AdminComponents/Modals/BulkClientsAdd";
import { useSelector } from "react-redux";
import axiosInstance from "../../../../api/Axios";

const { Title } = Typography;
const CourseClients = (props) => {
  const [messageApi, contextHolder] = message.useMessage();
  const userInfo = useSelector((state) => state.user);
  const { id } = useParams();
  const [loadAgain, setLoadAgain] = useState(false);
  const LoadAPI = () => {
    setLoadAgain((prev) => !prev);
  };
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");

  const DeleteSuccessfull = () => {
    messageApi.open({
      type: "success",
      content: "Client organization has been Deleted .",
      duration: 5,
    });

    setLoadAgain(true);
  };
  const DeleteFalied = () => {
    messageApi.open({
      type: "error",
      content: "Client organization Delete Failed",
      duration: 5,
    });
  };

  const handleDelete = async (record) => {
    try {
      await axiosInstance.delete(
        `/learn/courseorganizationdelete/${record.id}/`,
        {
          headers: {
            "X-CSRFToken": csrfToken,
          },
        }
      );
      DeleteSuccessfull();
    } catch (err) {
      DeleteFalied();
    }
  };

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRowsData, setSelectedRowsData] = useState([]);
  const [totalDeletableOnAllPages, setTotalDeletableOnAllPages] = useState(null);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);

  const onSelectChange = (newSelectedRowKeys, newSelectedRows) => {
    setSelectedRowKeys(newSelectedRowKeys);
    setSelectedRowsData((prev) => {
      // Keep items whose IDs are still in newSelectedRowKeys
      const filtered = prev.filter((item) => newSelectedRowKeys.includes(item.id));
      // Add new items from current page that are not already in filtered
      const newItems = newSelectedRows.filter(
        (item) => !filtered.some((f) => f.id === item.id)
      );
      return [...filtered, ...newItems];
    });
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record) => ({
      disabled: record?.is_deleted !== true, // Match individual delete availability
    }),
    preserveSelectedRowKeys: true,
  };

  const handleSelectAll = async (e) => {
    if (e.target.checked) {
      if (itemsLength > data?.length) {
        setLoading(true);
        try {
          const { search, active, filter_url } = filterData;
          let url = `/courseorganizationlist/?course_id=${id}&page_size=${itemsLength}`;
          if (search?.length > 1) url += `&search=${search}`;
          if (filter_url) url += `&${filter_url}`;
          url += `&status=${active ? "True" : "False"}`;

          const res = await axiosInstance.get(url);
          const allItems = res?.data?.results || [];
          const deletable = allItems.filter((item) => item.is_deleted === true);
          const deletableIds = deletable.map((item) => item.id);
          setSelectedRowKeys(deletableIds);
          setSelectedRowsData(deletable); // Store all deletable items for the modal list
          setTotalDeletableOnAllPages(deletableIds.length);
        } catch (err) {
          messageApi.error("Failed to select all items across pages.");
        } finally {
          setLoading(false);
        }
      } else {
        const deletable =
          data?.filter((item) => item.is_deleted === true) || [];
        const deletableIds = deletable.map((item) => item.id);
        setSelectedRowKeys(deletableIds);
        setSelectedRowsData(deletable);
        setTotalDeletableOnAllPages(deletableIds.length);
      }
    } else {
      setSelectedRowKeys([]);
      setSelectedRowsData([]);
    }
  };

  const handleBulkDelete = async () => {
    if (selectedRowKeys.length === 0) return;
    try {
      await axiosInstance.delete(`/learn/courseorganizationdelete/`, {
        data: { ids: selectedRowKeys },
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      messageApi.success("Selected clients have been deleted.");
      setSelectedRowKeys([]);
      setSelectedRowsData([]);
      setConfirmModalOpen(false);
      setLoadAgain((prev) => !prev);
    } catch (err) {
      messageApi.error("Bulk delete failed.");
    }
  };
  const {
    data,
    itemsLength,
    loading,
    setLoading,
    filterData,
    onShowSizeChange,
    onPageChange,
    handleSearchChange,
    // setFilterData,
    // handleSwitchChange,
    // handleClearAll,
    // setFilterUrl,
  } = useCommonListing({
    passSize: 10,
    passPage: 1,
    passURL: `/courseorganizationlist/?course_id=${id}`,
    loadAgain: loadAgain,
  });
  // eslint-disable-next-line no-unused-vars
  const { pageSize, currentPage, active, filter_url } = filterData;

  React.useEffect(() => {
    setSelectedRowKeys([]);
    setSelectedRowsData([]);
    setTotalDeletableOnAllPages(null);
  }, [filterData.search, filterData.filter_url, filterData.active, id]);
  const [isBulkModalOpen, setIsBulkModalOpen] = useState(false);
  const columns = [
    {
      title: "Client ID",
      dataIndex: "client_id",
      key: "client_id",
      width: 140,
    },
    {
      title: "Client Name",
      dataIndex: "client_name",
      key: "client_name",
      width: 250,
    },

    {
      title: "Assigned Date",
      dataIndex: "assigned_at",
      key: "assigned_at",
      width: 150,
      render: GetFormattedDateTime,
    },

    ...(props?.ImpersonateAccess
      ? [
          {
            title: "Actions",
            dataIndex: "id",
            key: "id",
            align: "center",
            width: 150,
            render: (text, record) =>
              record?.is_deleted === true ? (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Popconfirm
                    title={"Remove client?"}
                    description=" "
                    onConfirm={() => handleDelete(record)}
                    // onCancel={cancel}
                    okText="Yes"
                    cancelText="No"
                    placement="leftTop"
                  >
                    <DeleteTwoTone
                      key="delete"
                      style={{
                        cursor: "pointer",
                        fontSize: "1.6rem",
                        marginLeft: "0.9rem",
                      }}
                      title="delete"
                      twoToneColor="#eb2f96"
                    />
                  </Popconfirm>
                </div>
              ) : null,
          },
        ]
      : []),
  ];
  const modalColumns = [
    {
      title: "Client ID",
      dataIndex: "client_id",
      key: "client_id",
      width: 120,
    },
    {
      title: "Client Name",
      dataIndex: "client_name",
      key: "client_name",
    },
    {
      title: "Assigned Date",
      dataIndex: "assigned_at",
      key: "assigned_at",
      render: GetFormattedDateTime,
    },
  ];
  return (
    <Card style={{ width: "100%", marginBottom: "10px" }} hoverable>
      {contextHolder}
      <Title level={5} style={{ marginInline: "10px" }}>
        Associated Clients Summary
      </Title>
      <CommonTopDetails
        title={`Course Clients`}
        titleSuffix={`${itemsLength || 0} client(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        showAddButton={props?.ImpersonateAccess}
        filterAction={false}
        marginPass="15px"
        paddingInlinepass="10px"
        topSizeAdd="5px"
        addButtonProps={{
          modalType: "PopUP",
          modalProps: () => setIsBulkModalOpen((prev) => !prev),
        }}
        customContent={
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Checkbox
              checked={
                selectedRowKeys.length > 0 &&
                selectedRowKeys.length ===
                  (totalDeletableOnAllPages ??
                    data?.filter((item) => item.is_deleted === true).length)
              }
              indeterminate={
                selectedRowKeys.length > 0 &&
                selectedRowKeys.length <
                  (totalDeletableOnAllPages ??
                    data?.filter((item) => item.is_deleted === true).length)
              }
              onChange={handleSelectAll}
            >
              Select All
            </Checkbox>
            <Tooltip
              title={
                selectedRowKeys.length > 0
                  ? "Bulk Delete"
                  : "Select items to delete"
              }
            >
              <DeleteTwoTone
                onClick={() => {
                  if (selectedRowKeys.length > 0) {
                    setConfirmModalOpen(true);
                  }
                }}
                twoToneColor={
                  selectedRowKeys.length > 0 ? "#eb2f96" : "#d9d9d9"
                }
                style={{
                  fontSize: "1.6rem",
                  cursor:
                    selectedRowKeys.length > 0 ? "pointer" : "not-allowed",
                }}
              />
            </Tooltip>
          </div>
        }
      />
      <Table
        rowSelection={rowSelection}
        columns={columns}
        dataSource={data}
        rowKey="id"
        size="small"
        loading={loading}
        className="table-container"
        style={{ margin: "1rem" }}
        pagination={false}
        scroll={{
          x: 500,
        }}
        bordered
      />

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "1rem",
        }}
      >
        <Pagination
          size="small"
          showSizeChanger
          onShowSizeChange={onShowSizeChange}
          onChange={onPageChange}
          pageSizeOptions={["5", "10", "15", "20", "50"]}
          //   showQuickJumper
          current={currentPage}
          defaultPageSize={pageSize}
          total={itemsLength}
        />
      </div>
      <Modal
        title={
          <Title level={4} style={{ margin: 0 }}>
            Confirm Bulk Removal
          </Title>
        }
        open={confirmModalOpen}
        onOk={handleBulkDelete}
        onCancel={() => setConfirmModalOpen(false)}
        okText="Confirm Delete"
        cancelText="No"
        okButtonProps={{ danger: true }}
        width={500}
      >
        <p style={{ marginBottom: "15px" }}>
          Are you sure you want to remove the following{" "}
          <strong>{selectedRowKeys.length}</strong> client(s) from this course?
        </p>
        <div
          style={{
            maxHeight: "300px",
            overflowY: "auto",
            marginTop: "10px",
          }}
        >
          <Table
            size="small"
            columns={modalColumns}
            dataSource={selectedRowsData}
            pagination={false}
            rowKey="id"
            bordered
            scroll={{ x: 500, y: 240 }}
          />
        </div>
      </Modal>
      <BulkClientsAdd
        open={isBulkModalOpen}
        onClose={() => setIsBulkModalOpen(false)}
        userInfo={userInfo}
        course_id={id}
        LoadAPI={LoadAPI}
        callMain={props.LoadUser}
      />
    </Card>
  );
};

export default CourseClients;
